import { HOME_SCREEN_TABS, SEARCH_FIELDS } from '@/main/app.constants';

export enum TrainingPromptDisplay {
  NONE = 'NONE',
  HOME_SCREEN = 'HOME_SCREEN',
  POPOVER = 'POPOVER',
  MODAL = 'MODAL',
}

export const HOME_SCREEN_SORT = {
  UPDATED_AT: 'updatedAt',
  OPENED_AT: 'openedAt',
  CREATED_AT: 'createdAt',
  NAME: 'name',
  OWNER: 'owner',
  CREATOR: 'creator',
  SHARED_AT: 'sharedAt',
};

export const HOME_SCREEN_TABLE_TYPE = {
  TAB: 'table_on_tab',
  PINNED: 'pinned_table',
  RECENT: 'recent_table',
  SEARCH: 'search_results_table',
};

export interface SortByTableItem {
  key: string;
  sortProperty?: string;
  sortAsc?: boolean;
}

export interface PageSizeByTableItem {
  key: string;
  size: number;
}

export const HOME_SCREEN_CANCELLATION_GROUP = 'homeScreenRequest';

export const UNNAMED_REPORT = 'Unnamed';

export const ITEM_TYPES = {
  ANALYSIS: 'Analysis',
  ANY: 'Any',
  CONTEXT_COMMENT: 'ContextComment',
  FOLDER: 'Folder',
  PROJECT: 'Project',
  TOPIC: 'Topic',
  REPORT: 'Report',
  JOURNAL: 'Journal',
  VANTAGE: 'Vantage',
  ACTION_BOARD: 'ActionBoard',
};

export const JOURNAL_OR_REPORT = [ITEM_TYPES.REPORT, ITEM_TYPES.JOURNAL];

export const DEFAULT_TYPE = {
  text: 'HOME_SCREEN.TYPES.ANY',
  value: [
    ITEM_TYPES.ANALYSIS,
    ITEM_TYPES.FOLDER,
    ITEM_TYPES.REPORT,
    ITEM_TYPES.PROJECT,
    ITEM_TYPES.TOPIC,
    ITEM_TYPES.JOURNAL,
  ],
};

export const TYPE_OPTIONS = [
  {
    text: 'HOME_SCREEN.TYPES.ANY',
    value: DEFAULT_TYPE.value,
    icon: 'fa-cube workbenchDisplay',
  },
  {
    text: 'HOME_SCREEN.TYPES.ANALYSIS',
    value: [ITEM_TYPES.ANALYSIS, ITEM_TYPES.JOURNAL],
    icon: 'fc fc-analysis workbenchDisplay',
  },
  {
    text: 'HOME_SCREEN.TYPES.TOPIC',
    value: [ITEM_TYPES.TOPIC, ITEM_TYPES.REPORT],
    icon: 'fc fc-report workbenchDisplay',
  },
  {
    text: 'HOME_SCREEN.TYPES.PROJECT',
    value: ITEM_TYPES.PROJECT,
    icon: 'fc fc-seeq-datalab workbenchDisplay',
  },
  {
    text: 'HOME_SCREEN.TYPES.FOLDER',
    value: ITEM_TYPES.FOLDER,
    icon: 'fa-folder-open sq-text-primary workbenchDisplay',
  },
  {
    text: 'HOME_SCREEN.TYPES.JOURNAL',
    value: ITEM_TYPES.JOURNAL,
    icon: 'fa-book workbenchAnalysis workbenchDisplay',
  },
  {
    text: 'HOME_SCREEN.TYPES.REPORT',
    value: ITEM_TYPES.REPORT,
    icon: 'fa-book workbenchReport workbenchDisplay',
  },
];

export const SEARCH_FIELD_OPTIONS = [
  {
    text: 'HOME_SCREEN.SEARCH_FIELDS.ALL',
    value: SEARCH_FIELDS.ALL,
  },
  {
    text: 'HOME_SCREEN.SEARCH_FIELDS.CONTENT',
    value: SEARCH_FIELDS.CONTENT,
  },
  {
    text: 'HOME_SCREEN.SEARCH_FIELDS.DESCRIPTION',
    value: SEARCH_FIELDS.DESCRIPTION,
  },
  {
    text: 'HOME_SCREEN.SEARCH_FIELDS.NAME',
    value: SEARCH_FIELDS.NAME,
  },
];

export const MIN_HOME_SCREEN_ITEM_COUNT = 5;

export const tabFolders = (options: {
  isAdmin: boolean;
  includeCorporate?: boolean;
  includeExternallyShared?: boolean;
}) => {
  const tabs = [HOME_SCREEN_TABS.MY_FOLDER];
  if (options.includeCorporate) {
    tabs.push(HOME_SCREEN_TABS.CORPORATE);
  }
  if (options.includeExternallyShared) {
    tabs.push(HOME_SCREEN_TABS.EXTERNALLY_SHARED);
  }
  if (options.isAdmin) {
    tabs.push(HOME_SCREEN_TABS.USERS);
  }
  return tabs;
};

export enum DISPLAY_LOCATION {
  CURRENT_PAGE,
  NEW_TAB,
}

export const TRAINING_PROMPT_ID = 'trainingPrompt';
